import { twClassMerge } from '@healthhub/react-ui';
import { Typography } from 'antd';
import { memo } from 'react';

import { FilledCalendarAddIcon } from '@shared/assets-icon';

const { Text } = Typography;

interface DateSelectorProps {
  className?: string;
  iconLabel?: string;
  isDisabled?: boolean;
  onClick?: () => void;
  required?: boolean;
  title: string;
  value?: string;
}

const DateSelector = ({ className, iconLabel, isDisabled, onClick, required, title, value }: DateSelectorProps) => (
  <div>
    <div
      className={twClassMerge(
        'date-selector flex h-14 cursor-pointer items-center justify-between hover:border-slate-400 hover:opacity-70 rounded-lg border-2 border-solid bg-white p-4',
        className,
        isDisabled && 'opacity-50 bg-functional-stone hover:border-functional-stone hover:opacity-50 cursor-not-allowed'
      )}
      {...(!isDisabled && {
        onClick,
      })}
      role="button"
      tabIndex={0}
    >
      <div className="flex flex-col">
        <Text className="text-xs">
          {!!required && <Text className="text-xs text-error-color">*</Text>}
          <span
            className={twClassMerge('text-functional-iron', {
              'text-base': !value,
            })}
          >
            {title}
          </span>
        </Text>
        <Text className="text-base font-semibold">{value}</Text>
      </div>
      {!iconLabel ? (
        <FilledCalendarAddIcon className="size-5 md:size-6" />
      ) : (
        <span className="font-semibold text-sky-600">{iconLabel}</span>
      )}
    </div>
    {!value && !!required && <Text className="ml-4 mt-2 block text-xs text-functional-iron">Required</Text>}
  </div>
);

export default memo(DateSelector);
